import { createSlice } from "@reduxjs/toolkit";

const initialStateValue = {
  initialLoad: true,
  saveDone: false,
  receiptType: "",
  remainingCreditAmt: 0,
  gridRows: [],
  thirdPartyNameDisplayFlag: false,
  thirdPartyNameDisableModeFlag: true,
  currentRowAppBranch: "",
  currentRowBranchAppNums: [],
  currentRowBranchGlAccounts: [],
  fileReceiptInitialState: {},
  fileReceiptInitialStateAfterFilter: {},
  sourceOfFundValues: [],
  screenMode: "",
  prepayReceiptMode: false,
  prePayDetails: {
    prepayReason: null,
    bankAndInstructions: null,
    takeOverReason: null,
    effectiveDate: null,
    prepayNarration: "",
    prepayReasonTouched: false,
    bankInstructionsTouched: false,
    takeOverReasonTouched: false,
    prepayEffectiveDateTouched: false,
    prepayEffectiveDateIsValid: false,
    prepayEffectiveDateHasError: false,
    prepayEffectiveDateValidDateError: false,
    prepayNarrationTouched: false,
  },
  dateEnableDetails: {
    chequeDateEnable: false,
    bankDateEnable: false,
    voucherDateEnable: false,
    bankingDateEnable: false,
    realizationDateEnable: false,
  },
  voucherDateValidDateError: false,
  fileReceiptLovData: {
    targetFields: [],
    lovDataValue: {},
  },
  saveRequestActive: false,
  currentReceiptCustomerData: {},
  duplicateChequeNumHasError: false,
  duplicateChequeNumErrorMsg: "",
};
const FileReceiptGridReducer = createSlice({
  name: "fileReceiptGrid",
  initialState: initialStateValue,
  reducers: {
    updateDuplicateChequeNumHasError(state, action) {
      state.duplicateChequeNumHasError = action.payload;
    },
    updateDuplicateChequeNumErrorMsg(state, action) {
      state.duplicateChequeNumErrorMsg = action.payload;
    },
    updateCurrentReceiptCustomerData(state, action) {
      state.currentReceiptCustomerData = action.payload;
    },
    updateSaveRequestActive(state, action) {
      state.saveRequestActive = action.payload;
    },
    updateLovTargetFields(state, action) {
      state.fileReceiptLovData.targetFields = action.payload;
    },
    updateLovDataValue(state, action) {
      state.fileReceiptLovData.lovDataValue = action.payload;
    },
    updateScreenMode(state, action) {
      state.screenMode = action.payload;
    },
    updatePrePayReceiptMode(state, action) {
      state.prepayReceiptMode = action.payload;
    },
    resetPrepayDetails(state, action) {
      state.prePayDetails = initialStateValue.prePayDetails;
    },
    updatePrepayReason(state, action) {
      state.prePayDetails.prepayReason = action.payload;
    },
    updatePrepayReasonTouched(state, action) {
      state.prePayDetails.prepayReasonTouched = action.payload;
    },
    updateBankAndInstructions(state, action) {
      state.prePayDetails.bankAndInstructions = action.payload;
    },
    updateBankAndInstructionsTouched(state, action) {
      state.prePayDetails.bankInstructionsTouched = action.payload;
    },
    updateTakeOverReason(state, action) {
      state.prePayDetails.takeOverReason = action.payload;
    },
    updateTakeOverReasonTouched(state, action) {
      state.prePayDetails.takeOverReasonTouched = action.payload;
    },
    updatePrepayEffectiveDate(state, action) {
      state.prePayDetails.effectiveDate = action.payload;
    },
    updatePrepayEffectiveDateTouch(state, action) {
      state.prePayDetails.prepayEffectiveDateTouched = action.payload;
    },
    updatePrepayEffectiveDateIsValid(state, action) {
      state.prePayDetails.prepayEffectiveDateIsValid = action.payload;
    },
    updatePrepayEffectiveDateHasError(state, action) {
      state.prePayDetails.prepayEffectiveDateHasError = action.payload;
    },
    updatePrepayEffectiveDateValidDateError(state, action) {
      state.prePayDetails.prepayEffectiveDateValidDateError = action.payload;
    },
    updatePrepayNarration(state, action) {
      state.prePayDetails.prepayNarration = action.payload;
    },
    updatePrepayNarrationTouched(state, action) {
      state.prePayDetails.prepayNarrationTouched = action.payload;
    },
    updateSourceOfFundValues(state, action) {
      state.sourceOfFundValues = action.payload;
    },
    updateFileReceiptInitialState(state, action) {
      state.fileReceiptInitialState = action.payload;
    },
    updateFileReceiptInitialStateAfterFilter(state, action) {
      state.fileReceiptInitialStateAfterFilter = action.payload;
    },
    updateCurrentRowAppBranch(state, action) {
      state.currentRowAppBranch = action.payload;
    },
    updateCurrentRowBranchAppNums(state, action) {
      state.currentRowBranchAppNums = action.payload;
    },
    updateCurrentRowBranchGlAccounts(state, action) {
      state.currentRowBranchGlAccounts = action.payload;
    },
    updateRemainingCreditAmt(state, action) {
      state.remainingCreditAmt = Number(action.payload);
    },
    updateGridRows(state, action) {
      const rows = action.payload;
      state.remainingCreditAmt = rows.reduce(
        (val, { creditAmt }) => Number(val) + Number(creditAmt),
        0
      );
      state.gridRows = action.payload;
    },
    resetGridRows(state, action) {
      state.gridRows = [];
      state.remainingCreditAmt = 0;
    },
    updateInitialLoad(state, action) {
      state.initialLoad = action.payload;
    },
    updateSaveDone(state, action) {
      state.saveDone = action.payload;
    },
    updateReceiptType(state, action) {
      state.receiptType = action.payload;
    },
    updateThirdPartDisplayFlag(state, action) {
      state.thirdPartyNameDisplayFlag = action.payload;
    },
    updateThirdPartyNameDisableModeFlag(state, action) {
      state.thirdPartyNameDisableModeFlag = action.payload;
    },
    updateVoucherDateValidDateError(state, action) {
      state.voucherDateValidDateError = action.payload;
    },

    updateDateEnableDetails(state, action) {
      state.dateEnableDetails = action.payload;
    },
  },
});
export const FileReceiptGridReducerAction = FileReceiptGridReducer.actions;
export default FileReceiptGridReducer.reducer;
